import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { IDataFilter } from '../commons/types/interfaces/filters.interfaces';
import { IUser, IUserListResponse } from '../commons/types/interfaces/users.interfaces';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) {}

  getUsers(): Observable<any> {
    const url = `${environment.BASE_URL}/users`;
    return this.http.get<IUserListResponse>(url);
  }

  update(id: string | undefined, payload: IUser): Observable<any> {
    const url = `${environment.BASE_URL}/users/${id}`;
    return this.http.put<IUserListResponse>(url, payload);
  }

  create(payload: IUser): Observable<any> {
    const url = `${environment.BASE_URL}/users`;
    return this.http.post<IUserListResponse>(url, payload);
  }
  
  getUser(identityPlatformId: String): Observable<any> {
    const url = `${environment.BASE_URL}/users/${identityPlatformId}`;
    return this.http.get<IUserListResponse>(url);
  }

  resetPassword(userId: string, payload: IUser): Observable<any> {
    const url = `${environment.BASE_URL}/users/${userId}/reset-password`;
    return this.http.post<IUserListResponse>(url, payload);
  }
}
